<!-- ================= Hero (top section) ================= -->
<div class="blank-page hero-row">

  <div class="hero-side">
    <div class="sideBox-height">
      <div class="top-left"></div>
    </div>
    <div class="sideBox-height">
      <div class="circle-wrap">
        <div class="center-left"><i class="iconoir-coins"></i></div>
        <div class="floating-note">Expande o business de Cabinda ao Cunene.</div>
      </div>
    </div>
    <div class="sideBox-height">
      <div class="circle-wrap">
        <div class="bottom-left"></div>
        <div class="floating-note floating-note-icon">
          <i class="iconoir-stats-up-square"></i> Get Analytics of your store
        </div>
      </div>
    </div>
  </div>

  <div class="hero-center hero-copy">
    <p class="hero-kicker">{{ t().hero.kicker }}</p>
    <h1 class="hero-title">{{ t().hero.title }}</h1>
    <p class="hero-subtitle">{{ t().hero.subtitle }}</p>
    <div class="cta-row hero-cta-row">
      <a class="btn btn-solid" routerLink="/auth/register">{{ t().hero.ctaPrimary }}</a>
      <a class="btn btn-line" href="#">{{ t().hero.ctaSecondary }}</a>
    </div>
  </div>

  <div class="hero-side">
    <div class="sideBox-height">
      <div class="top-right"></div>
    </div>
    <div class="sideBox-height">
      <div class="circle-wrap">
        <div class="center-right"><i class="iconoir-map-pin"></i></div>
        <div class="floating-note floating-note-right">Nunca foi mais facil encotrar servicos e produtos</div>
      </div>
    </div>
    <div class="sideBox-height">
      <div class="circle-wrap">
        <div class="bottom-right"></div>
        <div class="floating-note floating-note-right">Pronto para o seu negócio crescer</div>
      </div>
    </div>
  </div>

</div>

<!-- ================= Temus Merchant landing content ================= -->
<div class="temus-landing">

  <header class="masthead">
    <div class="wrap">
      <div class="mark"><span class="pin" aria-hidden="true"></span>{{ t().brand }} <span class="sub">{{ t().brandSub }}</span></div>
      <div class="masthead-right">
        <nav>
          <a href="#location">{{ t().nav.location }}</a>
          <a href="#profile">{{ t().nav.listing }}</a>
          <a href="#sell">{{ t().nav.selling }}</a>
          <a href="#customers">{{ t().nav.customers }}</a>
          <a href="#setup">{{ t().nav.setup }}</a>
        </nav>
        <span class="lang-switch">
          <a [routerLink]="['/merchant', 'en']" [class.active]="lang() === 'en'">EN</a>
          <span class="lang-sep">/</span>
          <a [routerLink]="['/merchant', 'pt']" [class.active]="lang() === 'pt'">PT</a>
        </span>
      </div>
    </div>
  </header>

  <main>

    <section class="hero">
      <img class="hero-illustration" src="assets/images/illustrations/delivery-location.svg" alt="" aria-hidden="true" />
      <img class="hero-illustration-left" src="assets/images/illustrations/search-engines.svg" alt="" aria-hidden="true" />
      <div class="wrap">
        <div>
          <h1>{{ t().landing.heroTitle }}</h1>
          <p class="lede">{{ t().landing.lede1 }}</p>
          <p class="lede">{{ t().landing.lede2 }}</p>
          <div class="cta-row">
            <a class="btn btn-solid" routerLink="/auth/register">{{ t().landing.ctaCreate }}</a>
            <a class="btn btn-line" href="#location">{{ t().landing.ctaLocation }}</a>
          </div>
        </div>

        <div class="plate" role="img" [attr.aria-label]="t().landing.plate.valCountry + ', ' + t().landing.plate.valProvince + ', ' + t().landing.plate.valMunicipality + ', ' + t().landing.plate.valCity + ', ' + t().landing.plate.valSuburb + ', ' + t().landing.plate.valStreet">
          <div class="plate-head"><span>{{ t().landing.plate.addressOnFile }}</span><span>{{ t().landing.plate.verified }}</span></div>
          <ol class="chain">
            <li style="--d:0"><span class="tier">{{ t().landing.plate.tierCountry }}</span><span class="place">{{ t().landing.plate.valCountry }}</span></li>
            <li style="--d:1"><span class="tier">{{ t().landing.plate.tierProvince }}</span><span class="place">{{ t().landing.plate.valProvince }}</span></li>
            <li style="--d:2"><span class="tier">{{ t().landing.plate.tierMunicipality }}</span><span class="place">{{ t().landing.plate.valMunicipality }}</span></li>
            <li style="--d:3"><span class="tier">{{ t().landing.plate.tierCity }}</span><span class="place">{{ t().landing.plate.valCity }}</span></li>
            <li style="--d:4"><span class="tier">{{ t().landing.plate.tierSuburb }}</span><span class="place">{{ t().landing.plate.valSuburb }}</span></li>
            <li style="--d:5" class="final"><span class="tier">{{ t().landing.plate.tierStreet }}</span><span class="place">{{ t().landing.plate.valStreet }}</span></li>
          </ol>
          <div class="coords"><span>{{ t().landing.plate.pinned }}</span><span>{{ t().landing.plate.coords }}</span></div>
        </div>
      </div>
    </section>

    <section class="band" id="profile">
      <div class="wrap">
        <p class="kicker">{{ t().profile.kicker }}</p>
        <h2>{{ t().profile.title }}</h2>
        <p class="sect-note">{{ t().profile.note }}</p>

        <div class="rows">
          @for (row of t().profile.rows; track row.title) {
            <div class="row">
              <h3>{{ row.title }}</h3>
              <p>{{ row.desc }}</p>
            </div>
          }
        </div>
      </div>
    </section>

    <section class="band band-dark" id="location">
      <img class="location-illustration" src="assets/images/illustrations/my-location.svg" alt="" aria-hidden="true" />
      <div class="wrap">
        <p class="kicker">{{ t().location.kicker }}</p>
        <h2>{{ t().location.title }}</h2>
        <p class="sect-note">{{ t().location.note }}</p>

        <div class="steps">
          @for (step of t().location.steps; track step.title) {
            <div class="step">
              <span class="n">{{ step.n }}</span>
              <h3>{{ step.title }}</h3>
              <p>{{ step.desc }}</p>
            </div>
          }
        </div>
      </div>
    </section>

    <section class="band" id="sell">
      <div class="wrap">
        <p class="kicker">{{ t().sell.kicker }}</p>
        <h2>{{ t().sell.title }}</h2>
        <p class="sect-note">{{ t().sell.note }}</p>

        <div class="split">
          <div>
            <ul>
              @for (item of t().sell.col1; track item.lead) {
                <li><strong>{{ item.lead }}</strong> {{ item.desc }}</li>
              }
            </ul>
          </div>
          <div>
            <ul>
              @for (item of t().sell.col2; track item.lead) {
                <li><strong>{{ item.lead }}</strong> {{ item.desc }}</li>
              }
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="band" id="customers">
      <div class="wrap">
        <p class="kicker">{{ t().customers.kicker }}</p>
        <h2>{{ t().customers.title }}</h2>
        <p class="sect-note">{{ t().customers.note }}</p>

        <div class="rows">
          @for (row of t().customers.rows; track row.title) {
            <div class="row">
              <h3>{{ row.title }}</h3>
              <p>{{ row.desc }}</p>
            </div>
          }
        </div>
      </div>
    </section>

    <section class="band" id="team">
      <img class="team-illustration" src="assets/images/illustrations/secure-password.svg" alt="" aria-hidden="true" />
      <div class="wrap">
        <p class="kicker">{{ t().team.kicker }}</p>
        <h2>{{ t().team.title }}</h2>
        <p class="sect-note">{{ t().team.note }}</p>

        <div class="split">
          <div>
            <ul>
              @for (item of t().team.col1; track item.lead) {
                <li><strong>{{ item.lead }}</strong> {{ item.desc }}</li>
              }
            </ul>
          </div>
          <div>
            <ul>
              @for (item of t().team.col2; track item.lead) {
                <li><strong>{{ item.lead }}</strong> {{ item.desc }}</li>
              }
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="band" id="setup">
      <div class="wrap">
        <img class="setup-illustration" src="assets/images/illustrations/setup-wizard.svg" alt="" aria-hidden="true" />
        <p class="kicker">{{ t().setup.kicker }}</p>
        <h2>{{ t().setup.title }}</h2>
        <p class="sect-note">{{ t().setup.note }}</p>

        <div class="steps">
          @for (step of t().setup.steps; track step.title) {
            <div class="step">
              <span class="n">{{ step.n }}</span>
              <h3>{{ step.title }}</h3>
              <p>{{ step.desc }}</p>
            </div>
          }
        </div>
      </div>
    </section>

    <section class="band band-dark close">
      <img class="close-illustration" src="assets/images/illustrations/the-search.svg" alt="" aria-hidden="true" />
      <div class="wrap">
        <h2>{{ t().close.title }}</h2>
        <p>{{ t().close.desc }}</p>
        <div class="cta-row">
          <a class="btn btn-solid" routerLink="/auth/register">{{ t().close.ctaCreate }}</a>
          <a class="btn btn-line" href="#">{{ t().close.ctaTalk }}</a>
        </div>
      </div>
    </section>

  </main>

  <footer>
    <div class="wrap">
      <span>{{ t().footer.brand }}</span>
      <span>{{ t().footer.poweredBy }}</span>
    </div>
  </footer>

</div>
